const MAP_TIPO_PERICIA_SIBE_PMF = new Map([
  ["PMAN", "INSS_PMANPMF"],
  ["PMC", "INSS_PMCPMF"],
  ["PMRES", "INSS_PMRESPMF"]
]);

const MAP_TIPO_PERICIA_AGENDA_PMF = new Map([
  ["PMAN", "APMCPMF"],
  ["PMC", "APMCPMF"],
  ["PMRES", "APMRESPMF"]
]);

const MAP_TIPO_SIBE_PERICIA_PMF = new Map([
  ["INSS_PMANPMF", "APMCPMF"],
  ["INSS_PMCPMF", "APMCPMF"],
  ["INSS_PMRESPMF", "APMRESPMF"]
]);

const MAP_TIPO_SIBE_TIPO_PERICIA_PMF = new Map([
  ["INSS_PMANPMF", "PMAN"],
  ["INSS_PMCPMF", "PMC"],
  ["INSS_PMRESPMF", "PMRES"]
]);


export const obterSiglaTipoPericiaPMF = (siglaTipoPericiaSIBE) => {
  return MAP_TIPO_PERICIA_SIBE_PMF.get(siglaTipoPericiaSIBE);
}

export const obterSiglaPericiaAgendavelPMF = (siglaTipoPericiaPMF) => {
  return MAP_TIPO_PERICIA_AGENDA_PMF.get(siglaTipoPericiaPMF);
}

export const obterSiglaPericiaSibe = (siglaTipoSibe) => {
  return MAP_TIPO_SIBE_PERICIA_PMF.get(siglaTipoSibe);
}

export const obterSiglaTipoPericiaTipoSibe = (siglaTipoSibe) => {
  return MAP_TIPO_SIBE_TIPO_PERICIA_PMF.get(siglaTipoSibe);
}